<template>
	<div class="run-status">
		<h3 class="diagnosis-title">运行状态</h3>
		<ul class="content">
			<li v-for="item in cardList" :key="item.key" :class="['card', `${item.class}`]">
				<div class="card-title">
					<i :class="['iconfont', `${item.icon}`]"></i>
					<span class="text">{{ item.title }}</span>
				</div>
				<div class="card-value">{{ item.value || '--' }}</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		detail: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		cardList() {
			const { totalVol, valveStatus, voltage, singal, temperature, pressure } = this.detail
			return [
				{ title: '累积量', icon: 'icon-liuliang', key: 'totalVol', value: totalVol },
				{
					title: '阀门',
					icon: 'icon-famen',
					key: 'valveStatus',
					value: valveStatus,
					class: valveStatus === '故障' ? 'alarm' : '',
				},
				{ title: '电压', icon: 'icon-dianya', key: 'voltage', value: voltage },
				{ title: '信号', icon: 'icon-xinhao', key: 'singal', value: singal },
				{ title: '温度', icon: 'icon-wendu', key: 'temperature', value: temperature },
				{ title: '压力', icon: 'icon-yali', key: 'pressure', value: pressure },
			]
		},
	},
}
</script>
<style lang="scss" scoped>
.content {
	padding-top: 20px;
	display: grid;
	gap: 4px;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: 85px 85px;
}
.card {
	overflow: hidden;
	white-space: nowrap;
	border-radius: 6px;
	padding: 12px 20px;
	background: linear-gradient(135deg, #f5f6fc 0%, #edeffa 100%);
	color: #4d6bff;
	font-size: 22px;
}
.card.alarm {
	background: linear-gradient(135deg, #faf7f6 0%, #f5eeeb 100%);
	color: #e5662e;
}
.card-title {
	display: flex;
	align-items: center;
}
.card-title .iconfont {
	font-size: 22px;
}
.card-title .text {
	margin-left: 8px;
	font-size: 16px;
	color: #3f465e;
}
.card-value {
	margin-top: 6px;
	font-weight: 500;
}
</style>
